<div class="d-flex" [pTooltip]="userActive ? 'Available' : 'Offline'" tooltipZIndex="2000">
  <fa-icon [icon]="['far', 'user-circle']" size="2x" class="avatar"> </fa-icon>
  <span class="presence-dot align-self-end" [class.active]="userActive"> &nbsp;</span>
</div>
